export default "__VITE_ASSET__DRUAAMkE__"